/*
 * EXPORTS
 */
export const buttonStyle = {
  backgroundColor: "rgba(244, 247, 254, 1)",
  color: "rgba(92, 55, 255, 1)",
  fontFamily: "Dm Sans",
  fontWeight: "500",
  fontSize: "16px",
  lineHeight: "32px",
  letterSpacing: "-0.22px",
  borderRadius: "10px",
};
